import { type Ref, useId } from 'react';
import { Toggle } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
interface AnswerVisibilityToggleProps {
  id: string;
  /** true = 정답 표시 */
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  /** 노출 관측을 붙일 루트. 추적은 TrackedAnswerVisibilityToggle 이 건다 */
  rootRef?: Ref<HTMLDivElement>;
}

/** 문제 목록 상단의 전역 "정답 보기" 토글 */
export const AnswerVisibilityToggle = ({
  id,
  checked,
  onCheckedChange,
  rootRef
}: AnswerVisibilityToggleProps) => {
  const {
    t
  } = useTranslation(['common']);
  const labelId = useId();
  return <div ref={rootRef} className="flex shrink-0 items-center gap-xs" data-sentry-component="AnswerVisibilityToggle" data-sentry-source-file="AnswerVisibilityToggle.tsx">
      <span id={labelId} className="text-body-md-semibold text-default">
        {t('common:detail.showAnswers')}
      </span>
      <Toggle id={id} aria-labelledby={labelId} checked={checked} onCheckedChange={onCheckedChange} data-sentry-element="Toggle" data-sentry-source-file="AnswerVisibilityToggle.tsx" />
    </div>;
};